
import React from 'react';
import { SignupFormField } from '@/schemas/signupFormSchema';
import { UseFormReturn } from 'react-hook-form';
import CheckboxField from './fields/CheckboxField';
import IconInputField from './fields/IconInputField';

interface DynamicSignupFieldProps {
  field: SignupFormField;
  form: UseFormReturn<any>;
}

const DynamicSignupField = ({ field, form }: DynamicSignupFieldProps) => {
  // Determine which field component to render based on the field type
  if (field.name === 'terms' || field.type === 'checkbox') {
    return <CheckboxField field={field} form={form} />;
  }
  
  // For all other field types, use the IconInputField
  return <IconInputField field={field} form={form} />;
};

export default DynamicSignupField;
